<app-dialog-banner text="{{dialogOptions.title}}" [dialogRef]="dialogRef" [dialogCloseValue]="dialogOptions.cancelValue"></app-dialog-banner>
<mat-dialog-content style="padding: 10px; width: calc(min(80vw - 40px, 530px));" [style.min-height]="dialogOptions.minHeight"  [style.min-width]="dialogOptions.minWidth" data-form-ready="true">
    <app-field-set [fieldSet]="dialogOptions.fieldSet" [initComplete]="true"></app-field-set>

    <div style="display:flex; margin-top: 10px">
        <button mat-raised-button color="primary" (click)="save()" 
        data-field-set-save [disabled]="saving">{{saving ? 'Saving...' : saveText}}</button>
        <div style="flex: 1"></div>
        <button mat-raised-button color="accent" (click)="cancel()" data-field-set-cancel>Cancel</button>
    </div>

</mat-dialog-content>
